<template>
  <div>
    <div class="date-label">
      <div class="line"></div>
      <div class="date">{{ card.created_at | formatDate }}</div>
    </div>
     <div :class="{ 'changelog-card': true, 'no-image': !image }">
      <img v-if="card.image" :src="card.image" alt="" />
      <div :class="!!card.image ? 'content' : 'content-full-width'">
        <div :class="['changelog-card-header', color]">
          {{ card.title}}
        </div>
        <div class="text-filling" v-html="compiledContent">
        </div>
        <div class="sign">©QRWaiter</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    card: Object
  },
  computed: {
    color() {
      if (this.card.priority == 'medium') return 'yellow';
      if (this.card.priority == 'high') return 'red';
      
      return 'white';
    },
    compiledContent() {
      const cafe_href = this.$store.getters['onlineMenuLink']();
      return this.card.content.replace(/%cafe_link%/g, `<a href="${cafe_href}" target="_blank" class="c-green">${cafe_href}</a>`);
    }
  }
};
</script>
<style scoped>
.changelog-card {
  position: relative;
  width: 100%;
  background: #1d1d1b;
  border-radius: 1.333vh;
  /* display: flex; */
  min-height: 27.777vh;
  margin-top: 3.333vh;
  clip-path: border-box;
}

.changelog-card img {
  border-radius: 1.333vh 1.333vh 0 0;
  width: 100%;
  /* min-height: 100%; */
  object-fit: cover;
  object-position: center;
}
.content {
  width: 100%;
  padding: 2.222vh;
}
.content-full-width {
  width: 100%;
  padding: 2.222vh;
}
.changelog-card-header {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #ededed;
  padding-bottom: 0.5555555555555556vh;
}
.white {
  border-bottom: 0.1111vh solid #ededed;
}
.red {
  border-bottom: 0.1111vh solid #e2223b;
}
.yellow {
  border-bottom: 0.1111vh solid #f96d1e;
}
.bisque {
  border-bottom: 0.111vh solid #ffd2a8;
}
.text-filling {
  padding: 2.222vh 0;
  font-size: 2.222vh;
  line-height: 2.5555vh;
  width: 100%;
  color: #ededed;
}
.sign {
  font-weight: normal;
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
}
.date-label {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3.333vh;
}
.date-label .date {
  position: absolute;
  margin: 0 auto;
  font-size: 2.2222222222222223vh;
  line-height: 2.5555555555555554vh;
  color: #908f8d;
  background: rgba(237, 237, 237, 0.9);
  padding: 0 3.3333333333333335vh;
}
.date-label .line {
  border-top: 0.11111vh solid #908f8d;
  min-width: 100%;
  margin: 1.2222222222222223vh;
}
.no-image {
  min-height: 0;
}
</style>
